import { render, staticRenderFns } from "./editLoginPassword.vue?vue&type=template&id=62c20c1e&scoped=true"
import script from "./editLoginPassword.vue?vue&type=script&lang=js"
export * from "./editLoginPassword.vue?vue&type=script&lang=js"
import style0 from "./editLoginPassword.vue?vue&type=style&index=0&id=62c20c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c20c1e",
  null
  
)

export default component.exports